import { create } from 'zustand';

import type { CurrentUser } from '../types';

interface AuthState {
  currentUser: CurrentUser | null;
  isInitializing: boolean;
  setCurrentUser: (user: CurrentUser | null) => void;
  setInitializing: (initializing: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  currentUser: null,
  isInitializing: true,
  setCurrentUser: (user) => set({ currentUser: user }),
  setInitializing: (initializing) => set({ isInitializing: initializing }),
}));
